import styled from 'styled-components';
import Button from 'components/Button/Button';
import type { HeaderRendererProps } from 'components/generic/Drawer/components/DefaultHeaderRenderer';
import { closeAllDrawers } from 'components/generic/Drawer/hooks/useDrawer';
import Icon from 'components/Icon/Icon';

const Header = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.ColorBorderSecondary};
    justify-content: space-between;
    align-items: center;
    height: ${({ theme }) => theme.Spacing48};
    padding: 0 ${({ theme }) => theme.Spacing8};
    flex-shrink: 0;
    gap: ${({ theme }) => theme.Spacing8};
`;

const StyledButton = styled(Button.WithIcon)`

`;

const Content = styled.div`
    flex: 1 1 auto;
`;

const ChatHeaderRenderer: React.FC<React.PropsWithChildren<HeaderRendererProps>> = ({ children, ...restProps }) => {
    return (
        <Header {...restProps}>
            <Content>{children}</Content>
            <StyledButton
                variant="navigation"
                icon={<Icon type="Close" size={16} />}
                onClick={() => closeAllDrawers()}
            />
        </Header>
    );
};

export default ChatHeaderRenderer;
